<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <v-select
            v-model="selectVal"
            :items="selectOptions"
            :label="label"
            :multiple="multiple"
            :item-text="itemText"
            :item-value="itemValue"
            :clearable="clearable"
            :loading="loading"
            :rules="rules"
            @change="change"
    >

        <template v-slot:prepend-item>
            <v-list-item
                    ripple
                    v-if="search"
            >
                <v-list-item-content>
                    <v-list-item-title>
                        <v-text-field
                                v-model="searchText"
                                append-icon="mdi-magnify"
                                label="Search"
                                single-line
                                hide-details
                        ></v-text-field>

                    </v-list-item-title>
                </v-list-item-content>
            </v-list-item>
            <v-list-item
                    v-if="multiple"
                    ripple
                    @click="toggle"
            >

                <v-list-item-content>
                    <v-list-item-title>全选</v-list-item-title>
                </v-list-item-content>
            </v-list-item>
            <v-divider class="mt-2"></v-divider>
        </template>

    </v-select>
</template>

<script>
  import {getSelecotrData} from '@/api/selector'

  export default {
    name: "ZSourceSelector",
    data() {
      return {
        items: [],
        searchText: '',
        loading: false
      }
    },
    props: {
      itemsList: {
        type: Array,
        default: () => []
      },
      source: {
        type: String,
        required: false,
        default: 'DicSelector'
      },
      param: {
        type: String,
        required: false,
        default: ''
      },
      value: {
        type: [String, Number, Array],
        required: false
      },
      multiple: {
        type: Boolean,
        required: false,
        default: false
      },
      rules: {
        type: Array,
        required: false,
        default: () => []
      },
      search: {
        type: Boolean,
        required: false,
        default: true
      },
      label: {
        type: String,
        required: false
      },
      clearable: {
        type: Boolean,
        required: false,
        default: true
      },
      initLoad: {
        type: Boolean,
        required: false,
        default: true
      },
      itemText: {
        type: String,
        required: false,
        default: 'label'
      },
      itemValue: {
        type: String,
        required: false,
        default: 'value'
      }
    },
    computed: {
      selectVal: {
        get() {
          return this.value
        },
        set(value) {
          this.$emit('input', value)
        }
      },
      selectOptions: {
        get() {
          if (this.searchText) {
            return this.items.filter(i => i[this.itemText].indexOf(this.searchText) != -1)
          } else {
            return this.items
          }
        }
      }
    },
    watch: {
      param(val) {
        if (val) {
          this.load()
        }
      },
      itemsList: {
        immediate: true,
        handler(newValue, oldValue) {
          if (!this.initLoad) {
            this.items = newValue;
          }
        }
      }
    },
    methods: {
      change(val) {
        this.$emit('changevalue', val);
      }
      ,
      load() {
        if (!this.source) {
          console.error("!this.source ")
          return
        }
        this.loading = true
        getSelecotrData(this.source, this.param).then(res => {
          this.items = res
          this.loading = false
        }).catch(err => {
          this.loading = false
          console.error(err)
        })
      }
      ,
      toggle() {
        if (this.selectVal && this.selectVal.length > 0) {
          this.selectVal = []
        } else {
          let all = this.items.map(i => i.value);
          this.selectVal = all
        }
      }
    }
    ,
    created() {
      if (this.initLoad) {
        this.load()
      }
    }
  }
</script>

<style scoped>

</style>